var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 188,
    height: 32,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#logo_svg__clip0)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.671 20.23h-1.876c-1.566 4.573-5.63 7.381-10.774 7.381-5.128 0-9.192-2.808-10.771-7.381h-1.89c1.612 5.623 6.562 9.322 12.66 9.322 6.042 0 10.989-3.699 12.65-9.322zm-12.649 4.884c5.254 0 8.626-3.963 8.626-8.967 0-5.003-3.372-8.967-8.626-8.967-5.305 0-8.627 3.963-8.627 8.967 0 5.004 3.322 8.967 8.627 8.967zm0-24.82c9.37 0 16.013 6.986 16.013 15.853S112.392 32 103.022 32c-9.42 0-16.013-6.986-16.013-15.853S93.602.294 103.022.294zM13.137 14.166c1.637 0 2.727-1.685 2.727-3.419s-1.289-3.27-2.925-3.27H7.288v6.689h5.85zM0 1.286h12.444c6.395 0 10.56 3.864 10.56 9.461 0 5.202-2.628 8.125-7.04 9.215l8.031 11.047h-9.122L7.288 19.912V31.01H0V1.285zm43.528 21.45l-3.42-7.53h-.1l-3.47 7.53h6.99zM39.463.294h1.29L55.327 31.01h-7.833l-1.488-3.072h-11.75L32.82 31.01h-7.833L39.463.294zm30.987 0c5.65 0 9.567 2.13 12.74 5.45l-5.007 4.755C76.1 8.47 73.423 7.18 70.45 7.18c-5.305 0-8.725 3.963-8.725 8.967 0 5.004 3.42 8.967 8.725 8.967 2.975 0 5.651-1.289 7.734-3.319l4.858 4.756C80.067 29.67 75.952 32 70.45 32c-9.42 0-16.112-6.986-16.112-15.853S61.03.294 70.449.294zm69.954 24.82c5.254 0 8.625-3.963 8.625-8.967 0-5.003-3.371-8.967-8.625-8.967-5.305 0-8.627 3.963-8.627 8.967 0 5.004 3.322 8.967 8.627 8.967zm0-24.82c9.369 0 16.012 6.986 16.012 15.853S149.773 32 140.404 32c-9.42 0-16.014-6.986-16.014-15.853S130.984.294 140.404.294zm28.755.991l11.551 17.636v-.037h7.238V31.01h-7.585l-11.601-17.686V31.01h-7.288V1.285h7.685zm18.789 11.829v3.002h-7.238v-3.002h7.238zm0-5.771v3.002h-7.238V7.343h7.238zm0-6.058v3.29h-7.238v-3.29h7.238z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "logo_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h188v32H0z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.cef495e2.svg";
export { ForwardRef as ReactComponent };